import { StrictNullable } from '@/shared/types/app.types'

export interface PatientFusionDataState {
    searchedId: StrictNullable<string>
}
export const initialPatientFusionDataState =
    (): PatientFusionDataState => ({
        searchedId: null
    })
